import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import page404 from '@/components/page404'
import MySwiper from '@/components/MySwiper'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/swiper',
      name: 'MySwiper',
      component: MySwiper
    },
    {
      path:'/404',
      name: 'page404',
      component: page404
    },
    {
      path: '*', // 页面不存在的情况下会跳到404页面
      redirect: '/404',
      name: 'notFound',
      hidden: true
    }

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js